export type IKeysUserPermissions =
  | 'can_access_inboxes'
  | 'can_create_additional_inboxes'
  | 'can_manage_inboxes'
  | 'can_manage_organization_inboxes'
  | 'can_manage_billing_settings'
  | 'can_manage_billing_compliance_settings'
  | 'can_manage_members'
  | 'can_manage_organization_settings'
  | 'can_manage_phone_checker'
  | 'can_access_phone_checker'
  | 'can_manage_security_settings'
  | 'can_manage_tags'
  | 'can_manage_contacts'
  | 'can_import_contacts'
  | 'can_export_contacts'
  | 'can_manage_conversations'
  | 'can_manage_integrations'
  | 'can_manage_clients'
  | 'can_manage_saved_replies'
  | 'can_reassign_conversations'
  | 'can_manage_broadcasts'
  | 'can_manage_organization_broadcasts'
  | 'can_manage_triggers'
  | 'can_manage_organization_triggers'
  | 'can_manage_keywords'
  | 'can_manage_organization_keywords'
  | 'can_access_analytics'
  | 'can_manage_oauth_applications'
  | 'can_manage_canned_messages'
  | 'can_manage_shared_canned_messages'
  | 'can_manage_custom_fields'
  | 'can_manage_referrals'
  | 'can_manage_website_chat_widget'
  | 'can_manage_text_bots'
  | 'can_manual_opt_in'
  | 'can_manage_campaigns'
  | 'can_create_contacts'
  | 'can_transfer_conversation'

export type IResponseUserPermissions = {
  [key in IKeysUserPermissions]: boolean
}

export type IResponseEventUserPermissions = {
  permissions: IResponseUserPermissions
}

export const userPermissionTitle: Partial<Record<IKeysUserPermissions, string>> = {
  can_manage_keywords: 'Can manage Keywords',
  can_manage_website_chat_widget: 'Can manage Website Chat Widget',
  can_manage_inboxes: 'Can manage Inboxes',
  can_manage_text_bots: 'Can access AI Agent',
  can_manage_broadcasts: 'Can access Broadcasts',
  can_manage_campaigns: 'Can access Campaigns',
  can_manage_triggers: 'Can access Triggers',
  can_access_analytics: 'Can access Analytics',
  can_manage_security_settings: 'Can manage Data & Security',
  can_manage_members: 'Can manage Members',
  can_manage_billing_settings: 'Can manage Billing',
  can_manual_opt_in: 'Can access Manual Opt-In',
  can_access_phone_checker: 'Can access PhoneCheckr',
  can_create_contacts: 'Can create Contacts',
  can_manage_contacts: 'Can manage Contacts',
  can_transfer_conversation: 'Can transfer Conversations',
  can_manage_referrals: 'Can manage Referrals',
}

export const userPermissionRequestTitle: Partial<Record<IKeysUserPermissions, string>> = {
  can_manage_keywords: 'Manage keywords',
  can_manage_website_chat_widget: 'Manage website chat widget',
  can_manage_inboxes: 'Manage inboxes',
  can_manage_text_bots: 'Access AI agent',
  can_manage_broadcasts: 'Access broadcasts',
  can_manage_campaigns: 'Access campaigns',
  can_manage_triggers: 'Access triggers',
  can_access_analytics: 'Access analytics',
  can_manage_security_settings: 'Manage data & security',
  can_manage_members: 'Manage members',
  can_manage_billing_settings: 'Manage billing',
  can_manual_opt_in: 'Access manual opt-in',
  can_access_phone_checker: 'Access PhoneCheckr',
  can_create_contacts: 'Create contacts',
  can_manage_contacts: 'Manage contacts',
  can_transfer_conversation: 'Transfer conversations',
  can_manage_referrals: 'Manage referrals',
}
